import { createReducer, createAction } from '@reduxjs/toolkit';
import { GetChatOrderEligibilityQuery, OrderSheetByIdQuery } from '__generated__/commerce';

interface HoianUser {
  _id: string;
  nickname: string;
}

type OrderSheet = OrderSheetByIdQuery['orderSheet'];

interface ChatOrderState {
  chatOrderEligibility: Record<string, GetChatOrderEligibilityQuery>;
  hoianUsers: Record<string, HoianUser>;
  orderSheets: Record<string, OrderSheet>;
}

export const setChatOrderEligibility = createAction<{
  baId: string;
  eligibility: GetChatOrderEligibilityQuery;
}>('chatOrder/setEligibility');

export const setHoianUser = createAction<{
  id: string;
  user: HoianUser;
}>('chatOrder/setHoianUser');

export const setOrderSheet = createAction<{
  storeOrderId: string;
  orderSheet: OrderSheet;
}>('chatOrder/setOrderSheet');

const initialState: ChatOrderState = {
  chatOrderEligibility: {},
  hoianUsers: {},
  orderSheets: {},
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(setChatOrderEligibility, (state, action) => {
      const { baId, eligibility } = action.payload;
      state.chatOrderEligibility[baId] = eligibility;
    })
    .addCase(setHoianUser, (state, action) => {
      const { id, user } = action.payload;
      state.hoianUsers[id] = user;
    })
    .addCase(setOrderSheet, (state, action) => {
      const { storeOrderId, orderSheet } = action.payload;
      state.orderSheets[storeOrderId] = orderSheet;
    });
});
